import { ErrorBoundary } from 'components';
import { AuthProvider, CustomThemeProvider, EventProvider } from 'contexts';
import { useMatchCurrentLocationRoutes } from 'hooks/current-path-route-match';
import { ErrorPage } from 'pages/error';
import { EventLogin } from 'pages/event/event-login';
import { PublicLogin } from 'pages/public-login';
import { PublicSignup } from 'pages/public-signup';
import { TermsOfService } from 'pages/terms-of-service';
import { Route, Routes } from 'react-router-dom';
import { TableDemo } from 'components/table/table-demo';
import { AppSetup } from 'AppSetup';

import 'styles/global.css';
import 'styles/App.css';

interface Props {}

export const EntryRouting = (props: Props) => {
    const routeMatches = useMatchCurrentLocationRoutes();
    const pathMatch = routeMatches ? routeMatches[0] : null;
    const eventAlias = pathMatch?.params.eventAlias;

    return (
        <CustomThemeProvider>
            <ErrorBoundary>
                <AuthProvider>
                    <Routes>
                        {/* public pages */}
                        <Route path="/login" element={<PublicLogin />} />
                        <Route path="/signup" element={<PublicSignup />} />
                        <Route path="/error" element={<ErrorPage />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route
                            path="/:eventAlias/login"
                            element={
                                <EventProvider eventAlias={eventAlias!}>
                                    <EventLogin />
                                </EventProvider>
                            }
                        />
                        <Route
                            path="/:eventAlias/signup"
                            element={
                                <EventProvider eventAlias={eventAlias!}>
                                    <EventLogin />
                                </EventProvider>
                            }
                        />

                        {/* Demo paths */}
                        <Route path="/table-demo" element={<TableDemo />} />

                        {/* Private paths */}
                        <Route path="*" element={<AppSetup eventAlias={eventAlias} />} />
                    </Routes>
                </AuthProvider>
            </ErrorBoundary>
        </CustomThemeProvider>
    );
};
